import isEmpty from 'lodash.isempty';
import { joinWithCommas } from './utils';

export default function program(hit, overline, simple = false) {
  const { title, url, intro_headline, stats } = hit;

  const renderedStats = isEmpty(stats)
    ? ``
    : stats.slice(0, 2).reduce(
      (acc, stat) =>
        `${acc}
      <div class="stat-group">
        <p class="stat-group__label">${stat.label}</p>
        <p class="stat-group__desc">${stat.value}</p>
      </div>`,
      '',
    );

  return `
  <div class="tease tease--search tease--program">
    ${overline ? `<span class="tease__overline">${joinWithCommas(hit[overline])}</span>` : ''}
    <a class="tease__inner" href="${url}">
      <div class="tease__text-mod">
        <div class="tease__hgroup">
          <h2 class="tease__h">
            <span class="tease__h-underline">${title}</span>
          </h2>
          ${intro_headline ? `<p class="tease__desc">${intro_headline}</p>` : ''}
        </div>
      </div>
      ${
  stats
    ? `<div class="${simple ? 'tease__stat-mod tease__stat-mod--simple' : 'tease__stat-mod'}">
        ${renderedStats}
      </div>`
    : ''
}
    </a>
  </div>`;
}
